const __WEBPACK_NAMESPACE_OBJECT__ = require("hal-json-normalizer");;